import { instance, errorService } from '@/services/api'
import { masterAPIs, screenType } from '@/services/authConstantsV1'
import { calculateGridHeight, showNotification, customComparator } from '@/services/calculate'
import { gridProperties } from '@/services/column.config'
import exportTemplates from '@/components/DynamicComponents/exportTemplates'
import importTemplates from '@/components/DynamicComponents/importTemplates'
import _ from 'lodash'
import { AgGridVue } from 'ag-grid-vue'
import Pagination from '@/components/DynamicComponents/Pagination'
import { tableName } from '@/services/config'

export default {
  components: {
    exportTemplates,
    importTemplates,
    'ag-grid-vue': AgGridVue,
    Pagination,
  },
  props: {
    tabKey: String,
    type: String,
    role: String,
    screenId: Number,
    columnSettings: Array,
  },
  data: function () {
    const checkLength = (rule, value, callback) => {
      const reg = /^(?!$)\d{0,8}(?:\.\d{1,2})?$/
      if (!reg.test(value)) {
        callback(new Error('Please enter valid life (e.g.: 12345678.12)'))
      } else {
        callback()
      }
    }
    const checkTextLength = (rule, value, callback) => {
      if (String(value).length > 100) {
        callback(
          new Error('Value must be less than or equals to 100 characters'),
        )
      } else {
        callback()
      }
    }
    return {
      exportClicked: false,
      headStyle: {
        'font-weight': 'bold',
        background: 'transparent !important',
        color: '#000000d9 !important',
        padding: '0 10px',
      },
      count: 0,
      loading: true,
      spinner: false,
      defaultSortedBy: 'assetClass',
      defaultSortOrder: true,
      page: 0,
      pageSize: 0,
      assetClassList: [],
      visible: false,
      modalTitle: '',
      form: {
        id: undefined,
        asset_Class: undefined,
        description: undefined,
        default_Field: 'GDS',
        gdS_Life: undefined,
        gdS_Method: undefined,
        gdS_Convention: undefined,
        adS_Life: undefined,
        adS_Method: undefined,
        adS_Convention: undefined,
        isActive: 1,
      },
      rules: {
        asset_Class: [
          {
            required: true,
            message: 'Please enter asset class Id',
            trigger: 'blur',
          },
          { validator: checkTextLength, trigger: 'blur' },
        ],
        description: [
          {
            required: true,
            message: 'Please enter asset class description',
            trigger: 'blur',
          },
          { validator: checkTextLength, trigger: 'blur' },
        ],
        default_Field: [
          {
            required: true,
            message: 'Please select default',
            trigger: 'change',
          },
        ],
        gdS_Life: [
          { required: true, message: 'Please enter life', trigger: 'blur' },
          { validator: checkLength, trigger: 'blur' },
        ],
        gdS_Method: [
          { required: true, message: 'Please enter method', trigger: 'blur' },
          { validator: checkTextLength, trigger: 'blur' },
        ],
        gdS_Convention: [
          {
            required: true,
            message: 'Please enter convention',
            trigger: 'blur',
          },
          { validator: checkTextLength, trigger: 'blur' },
        ],
        adS_Life: [
          { required: true, message: 'Please enter life', trigger: 'blur' },
          { validator: checkLength, trigger: 'blur' },
        ],
        adS_Method: [
          { required: true, message: 'Please enter method', trigger: 'blur' },
          { validator: checkTextLength, trigger: 'blur' },
        ],
        adS_Convention: [
          {
            required: true,
            message: 'Please enter convention',
            trigger: 'blur',
          },
          { validator: checkTextLength, trigger: 'blur' },
        ],
      },
      selectedRowKeys: [],
      loadRefresh: false,
      frameworkComponents: null,
      tableParams: null,
      width: '100%',
      height: '400px',
      uploadedFile: null,
      importClicked: false,
      importColDef: gridProperties.import.columns.assetClass,
      loadImport: false,
      filters: {},
      tableState: null,
      gridOptions: {
        alwaysShowVerticalScroll: true,
        debounceVerticalScrollbar: true,
        alwaysShowHorizontalScroll: true,
        headerHeight: 30,
        rowHeight: 28,
        suppressRowClickSelection: true,
        singleClickEdit: true,
        stopEditingWhenGridLosesFocus: true,
        tooltipShowDelay: 0,
        rowSelection: 'multiple',
        defaultColDef: {
          sortable: true,
          suppressMovable: true,
          comparator: customComparator,
          resizable: true,
          menuTabs: ['filterMenuTab'],
          filterParams: {
            buttons: ['apply'],
            newRowsAction: 'keep',
          },
        },
      },
      columnDefs: [],
    }
  },
  beforeMount() {
    const settings = JSON.parse(localStorage.getItem('userSettings'))
    this.pageSize = settings.application.defaultRecord
    this.userDetails = JSON.parse(localStorage.getItem('userDetails'))
    this.loadingConfig()
  },
  mounted() {
    this.$root.$on('deleteAssetClass', this.deleteAssetClass)
    this.$root.$on('editAssetClass', this.getAssetClassById)
    window.addEventListener('resize', this.getWindowSize)
  },
  beforeDestroy() {
    this.$root.$off('deleteAssetClass')
    this.$root.$off('editAssetClass')
    this.$off('updateTableData')
    window.removeEventListener('resize', this.getWindowSize)
  },
  watch: {
    tabKey() {
      if (this.tabKey === '7') {
        this.filters = {}
        const data = this.gridOptions.api.getFilterModel()
        Object.keys(data).forEach(element => {
          const filterComponent = this.gridOptions.api.getFilterInstance(
            element,
          )
          filterComponent.setModel(null)
        })
        this.assetClassList = []
        this.loading = true
        this.getColumnSettings(this.gridOptions)
      }
    },
  },
  methods: {
    loadingConfig() {
      this.frameworkComponents = gridProperties.master.frameworks
      this.gridOptions.isRowSelectable = node => {
        if (node.data) {
          if (node.data.isLinked || node.data.applicationId) return false
          else return true
        }
      }
      gridProperties.master.columns.assetClass.map(i => {
        if (i.field === 'action' || i.field === 'isActive' || !i.field) {
          i.hide = this.type === 'Template' || this.role !== 'Admin'
        }
      })
      this.columnDefs = gridProperties.master.columns.assetClass
    },

    // Refresh Asset Class
    refreshAssetClasses() {
      const data = this.gridOptions.api.getFilterModel()
      Object.keys(data).forEach(element => {
        const filterComponent = this.gridOptions.api.getFilterInstance(element)
        filterComponent.setModel(null)
      })
      this.loading = true
      this.loadRefresh = true
      this.assetClassList = []
      this.page = 0
      this.defaultSortedBy = 'assetClass'
      this.defaultSortOrder = true
      this.gridOptions.columnApi.applyColumnState({
        state: [
          {
            colId: 'assetClass',
            sort: 'asc',
          },
        ],
        defaultState: { sort: null },
      })
      this.selectedRowKeys = []
      this.gridOptions.api.destroyFilter()
      this.filters = {}
      this.getAssetClasses(this.gridOptions)
    },

    // Close the dialog
    handleCancel() {
      this.visible = false
      if (this.$refs.ruleForm) {
        this.$refs.ruleForm.resetFields()
      }
    },

    // Add New Asset Class
    addNew() {
      this.visible = true
      this.modalTitle = 'Add New Asset Class'
      this.form.id = null
      this.form.asset_Class = undefined
      this.form.description = undefined
      this.form.default_Field = 'GDS'
      this.form.gdS_Life = undefined
      this.form.gdS_Method = undefined
      this.form.gdS_Convention = undefined
      this.form.adS_Life = undefined
      this.form.adS_Method = undefined
      this.form.adS_Convention = undefined
      this.isActive = 1
      if (this.$refs.ruleForm) {
        this.$refs.ruleForm.resetFields()
      }
    },

    // Save Asset Class
    save() {
      this.$refs.ruleForm.validate(valid => {
        if (valid) {
          this.spinner = true
          let url = masterAPIs.assetClass.add
          let method = 'post'
          let req = {
            assetClass: this.form.asset_Class,
            description: this.form.description,
            defaultField: this.form.default_Field,
            gdsLife: this.form.gdS_Life,
            gdsMethod: this.form.gdS_Method,
            gdsConvention: this.form.gdS_Convention,
            adsLife: this.form.adS_Life,
            adsMethod: this.form.adS_Method,
            adsConvention: this.form.adS_Convention,
          }
          if (this.form.id) {
            method = 'patch'
            url = masterAPIs.assetClass.details(this.form.id)
            req = {
              assetClass: this.form.asset_Class,
              description: this.form.description,
              defaultField: this.form.default_Field,
              gdsLife: this.form.gdS_Life,
              gdsMethod: this.form.gdS_Method,
              gdsConvention: this.form.gdS_Convention,
              adsLife: this.form.adS_Life,
              adsMethod: this.form.adS_Method,
              adsConvention: this.form.adS_Convention,
              isActive: this.form.IsActive,
            }
          }
          instance[method](url, req)
            .then(response => {
              this.spinner = false
              this.visible = false
              showNotification(
                'success',
                this.form.id ? 'Update Asset Class' : 'Create Asset Class',
                this.form.id
                  ? 'Asset Class updated successfully!'
                  : 'Asset Class created successfully!',
              )
              if (this.form.id) {
                const newData = [...this.assetClassList]
                const index = newData.findIndex(i => i.id === this.form.id)
                newData[index] = _.get(response.data, 'result', null)
                this.assetClassList = newData
              } else {
                this.getAssetClasses(this.tableParams)
              }
              this.$refs.ruleForm.resetFields()
            })
            .catch(error => {
              this.spinner = false
              errorService(error)
            })
        }
      })
    },

    // Get Asset Class
    getAssetClasses(params, type) {
      const req = {
        pageSize: this.pageSize,
        currentPage: this.page,
        sortColumn: this.defaultSortedBy,
        isAscending: this.defaultSortOrder,
        assetClass: _.get(this.filters, 'assetClass', undefined),
        description: _.get(this.filters, 'description', undefined),
        defaultField: _.get(this.filters, 'defaultField', undefined),
        gdsLife: _.get(this.filters, 'gdsLife', undefined),
        gdsMethod: _.get(this.filters, 'gdsMethod', undefined),
        gdsConvention: _.get(this.filters, 'gdsConvention', undefined),
        adsLife: _.get(this.filters, 'adsLife', undefined),
        adsMethod: _.get(this.filters, 'adsMethod', undefined),
        adsConvention: _.get(this.filters, 'adsConvention', undefined),
      }
      instance
        .post(masterAPIs.assetClass.list, req)
        .then(response => {
          this.tableParams = null
          this.tableParams = params
          this.assetClassList = _.get(response.data, 'result', [])
          this.count = _.get(response.data, 'totalCount', 0)
          this.height = calculateGridHeight(
            'assetClassTable',
            this.count > this.pageSize,
          )
          this.loading = false
          this.loadRefresh = false
          if (type === 'sort') {
            this.updateColumnSettings()
          }
        })
        .catch(error => {
          this.loading = false
          this.loadRefresh = false
          errorService(error)
        })
    },

    // Get Asset Class By Id
    getAssetClassById(id) {
      this.modalTitle = 'Edit'
      this.visible = true
      this.spinner = true
      const url = masterAPIs.assetClass.details(id)
      instance
        .get(url)
        .then(response => {
          this.form['id'] = _.get(response.data, 'result.id', null)
          this.form['description'] = _.get(
            response.data,
            'result.description',
            null,
          )
          this.form['asset_Class'] = _.get(
            response.data,
            'result.assetClass',
            null,
          )
          this.form['default_Field'] = _.get(
            response.data,
            'result.defaultField',
            null,
          )
          this.form['gdS_Life'] = Number(
            _.get(response.data, 'result.gdsLife', null),
          )
          this.form['gdS_Method'] = _.get(
            response.data,
            'result.gdsMethod',
            null,
          )
          this.form['gdS_Convention'] = _.get(
            response.data,
            'result.gdsConvention',
            null,
          )
          this.form['adS_Life'] = Number(
            _.get(response.data, 'result.adsLife', null),
          )
          this.form['adS_Method'] = _.get(
            response.data,
            'result.adsMethod',
            null,
          )
          this.form['adS_Convention'] = _.get(
            response.data,
            'result.adsConvention',
            null,
          )
          this.spinner = false
        })
        .catch(error => {
          this.spinner = false
          errorService(error)
        })
    },

    confirmDelete(record) {
      this.loading = true
      const req = record ? [record.id] : this.selectedRowKeys
      instance
        .patch(masterAPIs.assetClass.delete, req)
        .then(response => {
          showNotification(
            'success',
            'Delete Asset Class',
            'Asset Class deleted successfully!',
          )
          this.refreshAssetClasses()
        })
        .catch(error => {
          this.loading = false
          errorService(error)
        })
    },

    // Delete All Asset Classes
    deleteAllType() {
      const that = this
      this.$confirm({
        title: `Are you sure you want to delete ${this.selectedRowKeys.length} selected asset classes ?`,
        content: h => (
          <div style="color:red;">
            <p>
              This action will delete all information related to selected asset
              classes
            </p>
            <p>Please confirm</p>
          </div>
        ),
        onOk() {
          that.confirmDelete()
        },
        onCancel() { },
        class: 'test',
      })
    },

    // Delete Asset Class
    deleteAssetClass(data) {
      const that = this
      this.$confirm({
        title: `Are you sure you want to delete '${this.type !== 'Template' ? data.assetClass : data.asset_Class
        }' ?`,
        content: h => (
          <div style="color:red;">
            <p>
              This action will delete all information related to this asset
              class
            </p>
            <p>Please confirm</p>
          </div>
        ),
        onOk() {
          that.confirmDelete(data)
        },
        onCancel() { },
        class: 'test',
      })
    },

    downloadTemplate() {
      this.exportClicked = true
    },

    clickedCancel() {
      this.exportClicked = false
    },

    onSelectChange(selectedRowKeys) {
      this.selectedRowKeys = selectedRowKeys
    },

    // Ag Grid sort method
    sortChanged(value) {
      const colState = this.gridOptions.columnApi.getColumnState()
      const sortData = colState
        .filter(function (s) {
          return s.sort != null
        })
        .map(function (s) {
          return {
            colId: s.colId,
            sort: s.sort,
            sortIndex: s.sortIndex,
          }
        })
      this.loading = true
      this.assetClassList = []
      if (sortData.length > 0) {
        this.defaultSortedBy = sortData[0]['colId']
        this.defaultSortOrder = sortData[0]['sort'] === 'asc'
      } else {
        this.defaultSortedBy = 'assetClass'
        this.defaultSortOrder = true
      }
      this.getAssetClasses(this.gridOptions, 'sort')
    },

    onRowSelected(event) {
      const selectedNodes = this.gridOptions.api.getSelectedNodes()
      const selectedData = selectedNodes.map(node => node.data.id)
      this.selectedRowKeys = selectedData
    },

    onSelectionChanged(event) {
      const selectedNodes = this.gridOptions.api.getSelectedNodes()
      const selectedData = selectedNodes.map(node => node.data.id)
      this.selectedRowKeys = selectedData
    },

    beforeUpload(file) {
      const isValid =
        file.type === 'xlsx' ||
        file.type === 'xls' ||
        file.type ===
        'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
      if (!isValid) {
        showNotification('error', 'Import', 'Please upload excel file only!')
      }
      return isValid
    },

    handleImport(event) {
      this.importClicked = true
      this.uploadedFile = event.file
      this.loadImport = true
    },

    clickedCancelimport(addedCount) {
      this.importClicked = false
      this.loadImport = false
      if (addedCount > 0) {
        this.refreshAssetClasses()
      }
    },

    updateTable() {
      this.importClicked = false
      this.refreshAssetClasses()
    },

    getWindowSize() {
      this.height = calculateGridHeight(
        'assetClassTable',
        this.count > this.pageSize,
      )
    },

    onPagination(page) {
      this.loading = true
      this.page = page
      this.assetClassList = []
      this.selectedRowKeys = []
      this.getAssetClasses(this.tableParams)
    },

    filterChanged() {
      this.filters = {}
      const data = this.gridOptions.api.getFilterModel()
      Object.keys(data).forEach((element, index) => {
        this.filters[element] = Object.values(data)[index]['filter']
      })
      this.loading = true
      this.page = 0
      this.assetClassList = []
      this.getAssetClasses(this.gridOptions)
    },

    onColumnResized(e) {
      if (e.finished) {
        this.updateColumnSettings()
      }
    },

    updateColumnSettings() {
      if (this.role === 'Admin') {
        this.tableState = this.gridOptions.columnApi.getColumnState()
        const request = {
          type: !this.type ? screenType.assetClass : undefined,
          screenId: this.type ? this.screenId : undefined,
          tableName: this.type ? tableName.template.master.assetClass : undefined,
          columnDetails: JSON.stringify(this.tableState),
        }
        if (!this.type) {
          this.$emit('updateColumns', request)
        } else {
          this.$emit('updateColumnSettings', request)
        }
      }
    },

    getColumnSettings(params) {
      if (this.type) {
        const columnDetails = this.columnSettings.find(
          i =>
            i.screenId === this.screenId &&
            i.tableName === tableName.template.master.assetClass,
        )
        this.setColumnSettings(
          params,
          columnDetails ? columnDetails.columnDetails : null,
        )
        this.getAssetClasses(this.gridOptions)
      } else {
        if (this.role === 'Admin') {
          instance
            .get(masterAPIs.columnSetting.get(screenType.assetClass))
            .then(response => {
              const tableState = _.get(
                response.data,
                'result.columnDetails',
                null,
              )
              this.setColumnSettings(params, tableState)
            })
            .catch(error => {
              this.spinner = false
              errorService(error)
            })
        } else {
          this.setColumnSettings(params)
        }
        this.getAssetClasses(this.gridOptions)
      }
    },

    setColumnSettings(params, tableState) {
      if (tableState && this.role === 'Admin') {
        this.tableState = JSON.parse(tableState)
        if (this.tableState.find(i => i.sort)) {
          this.defaultSortedBy = this.tableState.find(i => i.sort).colId
          this.defaultSortOrder =
            this.tableState.find(i => i.sort).sort === 'asc'
        }
        this.tableState[0].hide = !!this.type
        this.gridOptions.columnApi.applyColumnState({
          state: this.tableState,
        })
      } else {
        this.defaultSortedBy = 'assetClass'
        this.defaultSortOrder = true
        this.gridOptions.columnApi.applyColumnState({
          state: [
            {
              colId: 'assetClass',
              sort: 'asc',
            },
          ],
          defaultState: { sort: null },
        })
        params.api.sizeColumnsToFit()
      }
    },
  },
}
